export default {
  getRegulatorySymbol: (state) => state.regulatorySymbol,
};
